import React from "react";
import { Route, RouteProps } from "react-router-dom";
import AuthLayoutBlank from "layouts/AuthLayout/AuthLayoutBlank";

interface Props extends RouteProps {
  children: React.ReactNode;
}

const ProtectedRouteBlank = ({ children, ...otherProps }: Props) => (
  <Route {...otherProps}>
    <AuthLayoutBlank>{children}</AuthLayoutBlank>
  </Route>
);

export default ProtectedRouteBlank;
